<div class="container container-fluid center-content p-xs-1 p-sm-0">
	<div class="row">
		<div class="col-12 mb-3 pl-sm-0 pl-3">
			<mat-card appearance="outlined" class="mt-5 mat-card p-4">
				<mat-card-content class="ml-1 pl-md-4 pr-md-4">
					<h1 class="page-title mb-4 mt-3">
						<adp-label labelKey="Editor_PageHeader" ></adp-label>
					</h1>
					<div>
						<form class="p-0 col-md-6 col-sm-6" [formGroup]="form" id="verify-form">

							<div class="form-group" *ngIf="!isLoggedIn">
                <adp-input
                  [resourceData]="getResourceObject('Email')"
									formControlName="Email"
									class="w-100"
								></adp-input>
							</div>
							<div class="form-group" *ngIf="!isLoggedIn" >
                <adp-input
                  [resourceData]="getResourceObject('Password')"
									formControlName="Password"
									class="w-100"
								></adp-input>
              </div>
              <div *ngIf="errorKey">
                <adp-label [labelKey]="errorKey" ></adp-label> <br /><br />
              </div>

              <div *ngIf="isLoggedIn">
                <span><adp-label labelKey="Editor_LoggedinAs" ></adp-label> {{ contentEditorEmail }} </span>
                <br />
                <br />
                <a href="/cms">	<adp-label labelKey="Editor_ViewCMSPage" ></adp-label></a>
                <br />
                <br />
              </div>
							<button class="btn btn-primary new-btn-continue" *ngIf="!isLoggedIn"  [disabled]="!form.valid" (click)="login()">
                <adp-label labelKey="Editor_LogIn_Button" ></adp-label>
              </button>
              <button class="btn btn-primary new-btn-continue" *ngIf="isLoggedIn"  (click)="logout()">
                <adp-label labelKey="Editor_LogOut_Button" ></adp-label>
							</button>
						</form>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>
